// common helper functions
export const isNonNull = param => param !== undefined && param !== null;
export const isNumber = param => typeof param === 'number';
export const isObject = param => typeof param === 'object' && param !== null;

// common helper data
export const objectAttributes = ['style', 'dangerouslySetInnerHTML', 'data-', 'aria-'];